import { ACTION_CONSTANTS } from 'actions/constants';

export function openOverlay(props) {
  return dispatch => {
    return dispatch({
      type: ACTION_CONSTANTS.overlay.open,
      payload: props
    });
  };
}

export function closeOverlay() {
  return dispatch => {
    return dispatch({
      type: ACTION_CONSTANTS.overlay.close
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/overlay.js